import gql from 'graphql-tag'

export const localTypeDefs = gql`
  type Role {
    id: String
    name: String
    __typename: String
  }
`
